module.exports = __webpack_public_path__ + "static/anzisha-logo-462ecfcdf091789b04d06bb107de2ad8.png";